import IconBase from "./IconBase";

const GridIcon = props => (
  <IconBase {...props}>
    <g
      transform="translate(3 3)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    >
      <rect width="14" height="14" rx="2" />
      <path d="M7 0v14M0 7h14" />
    </g>
  </IconBase>
);

export default GridIcon;
